<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1 section" id="chapter-1">
<h1>Chapter 1</h1>
<div class="section level2 section" id="before-cancer-came-into-my-life">
<h2>Before Cancer Came into My Life</h2>
<p>Before I was ever diagnosed with cancer or the stomach pain that caused it in the first place ever started, I lived a reasonably good life. I did have epilepsy from 1966, when I was four years old, until 2006, when I was forty-four years old. That didn’t make life easy during my school days or when I finished school and was job-hunting for the first time. I had to take various tablets and medications during the forty years I had seizures, some of which were more serious and some more mild. Luckily for me, as the years passed by, the seizures became milder and occurred less often. Eventually, I grew out of them and they disappeared altogether. That was, and has been, a big relief.</p>
<p>Even though the epilepsy affected me during my early life and for quite a few years, I still tried to carry on living throughout the seizures I was experiencing and not let it get to me too much. My own character and personal strengths had a lot to do with it as was how my parents looked after me and all the love they showed me. I always kept myself reasonably active and more so as I was getting nearer to leaving school and after I had left school.</p>
<p>During my early life and even up to the day I was diagnosed, I had no thought of ever having cancer. Not ever experiencing it before my diagnosis made it harder to even imagine it would ever happen; plus, also living a reasonably healthy life. The majority of individuals that have experienced it at some time would not have imagined it before they were actually diagnosed with cancer.</p>
<p>Even on the day I had a stomach ache, before I was diagnosed, the thought of it being cancer just didn’t cross my mind. I was just thinking of getting better and hoping the stomach ache, I had at that time, would disappear.</p>
<p>When we are going about our everyday lives, whether we are active and busy or not, the thought of having cancer at some time in our lives very rarely crosses our minds. To be thinking of it on a regular basis throughout our lives just wouldn’t be normal and for myself, would be a very silly thing to do; plus, it wouldn’t help any of us in any way at all.</p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch004.vue?2a9c386c